export const ATTORNEY = "attorney";
export const BINDER = "binder";
export const CASE = "case";
export const COPYRIGHT = "copyright";
export const COURT = "court";
export const COURT_COMP = "court_comparison";
export const DOCUMENT = "document";
export const EXPERT = "expert";
export const FIRM = "firm";
export const FIRM_COMP = "firm_comparison";
export const JUDGE = "judge";
export const PARTY = "party";
export const PATENT = "patent";
export const TRADEMARK = "trademark";
